import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { domainsFastCheckout } from '../configuration/constants';
import { RoutesEnum } from '../configuration/enums/routes.enum';
import { getCompanyDomain } from '../utils/getCompanyDomain.util';

export const domainFastCheckoutGuard: CanActivateFn = () => {
  const router = inject(Router);
  const domain = getCompanyDomain();

  if (domainsFastCheckout.includes(domain)) {
    return true;
  } else {
    router.navigate([RoutesEnum.NOT_FOUND]);
    return false;
  }
};
